<template>
    <main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="presentation">
                    <li class="nav-item">
                        <a
                            :class="['nav-link', active_tab === 'factors' ? 'active' : '']"
                            @click="setTab('factors')"
                            data-toggle="tab"
                            href="#factors"
                            id="factors"
                            role="tab"
                            aria-selected="false"
                        >
                            {{ $t('aside.factors') }}
                        </a>
                    </li>
                    <li class="nav-item">
                      <a
                          :class="['nav-link', active_tab === 'items' ? 'active' : '']"
                          @click="setTab('items')"
                          data-toggle="tab"
                          id="items"
                          href="#items"
                          role="tab"
                          aria-selected="false"
                      >
                        {{ $t('aside.items') }}
                      </a>
                    </li>
                    <li class="nav-item">
                      <a
                          :class="['nav-link', active_tab === 'customers' ? 'active' : '']"
                          @click="setTab('customers')"
                          data-toggle="tab"
                          id="customers"
                          href="#customers"
                          role="tab"
                          aria-selected="false"
                      >
                        {{ $t('aside.customers') }}
                      </a>
                    </li>
                  <li class="nav-item">
                    <a
                        :class="['nav-link', active_tab === 'formats' ? 'active' : '']"
                        @click="setTab('formats')"
                        data-toggle="tab"
                        id="formats"
                        href="#formats"
                        role="tab"
                        aria-selected="false"
                    >
                      {{ $t('aside.formats') }}
                    </a>
                  </li>
                  <li v-if="$can('change-setting', 'payment-link')" class="nav-item">
                    <a
                        :class="['nav-link', active_tab === 'required_fields' ? 'active' : '']"
                        @click="setTab('required_fields')"
                        data-toggle="tab"
                        id="required-fields"
                        href="#required-fields"
                        role="tab"
                        aria-selected="false"
                    >
                      {{ $t('aside.required_fields') }}
                    </a>
                  </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
              <div v-if="active_tab === 'factors'" class="tab-pane fade show active" id="factors" role="tabpanel">
                <factors></factors>
              </div>
              <div v-if="active_tab === 'items'" class="tab-pane fade show active" id="items" role="tabpanel">
                <items></items>
              </div>
              <div v-if="active_tab === 'customers'" class="tab-pane fade show active" id="customers" role="tabpanel">
                <customers></customers>
              </div>
              <div v-if="active_tab === 'formats'" class="tab-pane fade show active" id="formats" role="tabpanel">
                <formats></formats>
              </div>
              <div v-if="active_tab === 'required_fields'">
                <required_fields />
              </div>
            </div>
        </kt-panel-body>
    </kt-panel>
    </main-content>
</template>

<script>
import Items from './GetItems';
import Factors from './Factors.vue';
import Customers from './Customers';
import MainContent from "../../components/main-content";
import Formats from "@/views/online-factor/formats.vue";
import Required_fields from "@/views/online-factor/required_fields.vue";

export default {
    components: {
      Required_fields,
      Formats,
        'items' : Items,
        'factors' : Factors,
        'customers' : Customers,
        'main-content' : MainContent,
    },
    data() {
        return {
          active_tab: "factors",
          query: {}
        }
    },
    computed: {
    },
    methods: {
      setTab(selected_tab) {
        this.active_tab = selected_tab;
      },
    }
}
</script>

<style>

</style>